
export const hasHiddenFeature = (session, feature) => {
    if (!session?.team_name?.toLowerCase()?.includes("fintrx") || session?.trial) {
        return false
    }
    return session?.has_hidden_features?.includes(feature);
}

export const hasAiAnalystEnabled = (session) => {
    return ["Premium", "Trial", "Lite"].includes(session?.ai_analyst_state);
}

// AI Analyst is not yet available for Banks & Trusts. Keep this gate returning
// false until the B&T analyst ships, then mirror hasAiAnalystEnabled here.
export const hasBtAiAnalystEnabled = (_session) => {
    return false;
}

export const hasCustomFeature = (session, customFeature) => {
    if (session?.team_name?.toLowerCase()?.includes("fintrx") && !session?.trial) {
        return false
    }
    return session?.custom_features?.includes(customFeature);
}

export const hasInHouseFeature = (session, feature) => {
    return (
        feature === 'IN_HOUSE' &&
        !session.live_trial &&
        (
            session?.team_name?.toLowerCase()?.includes('fintrx') ||
            ['fintrx', 'capitalhedge'].some(k => session?.email?.toLowerCase()?.includes(k))
        )
    )
}

export const hasFinAlertsAccess = (session) => {
    return session?.fin_capabilities?.fixed_alerts ?? ['standard', 'premium'].includes(session?.fin_tier);
}

export const isFinTierActivePremium = (session) => {
    return ['premium', 'trial'].includes(session?.fin_tier);
}

export const featureFlag = (session, hiddenFeature, customFeature) => {
    return (
        session?.team_id === 1467 ||
        hasHiddenFeature(session, 'TEST') ||
        hasHiddenFeature(session, hiddenFeature) ||
        hasCustomFeature(session, customFeature) ||
        hasInHouseFeature(session, hiddenFeature)
    )
}
